// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)
Vue.use(Vuex);

import 'jquery'

//引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//隐藏类
import 'element-ui/lib/theme-chalk/display.css';

// 国际化
import vueI18n from 'vue-i18n'
//引入Element的语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import jpLocale from 'element-ui/lib/locale/lang/ja'
import "../node_modules/swiper/swiper.min.css"

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)


//引入百度地图
import BaiduMap from 'vue-baidu-map'

import './assets/styles/index.scss'

/*var sUserAgent = navigator.userAgent.toLowerCase();
if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
  //跳转移动端页面
  console.log('移动端');
  require('./assets/styles/mobile/index.scss');
} else {
  //跳转pc端页面
  console.log('pc端');
  require('./assets/styles/index.scss');
}*/


Vue.use(BaiduMap, {
  ak: '6IgSHBYxqOvCFrTssgeVHjS0XRWcKMoA'
});

Vue.use(vueI18n);

console.log(localStorage.lang);
console.log("localStorage",localStorage.getItem('lang'));
if (localStorage.getItem('lang')) {
  localStorage.lang = localStorage.getItem('lang')
}
//  else {
//   localStorage.lang = "zh-cn"
// }
//注册i18n实例并引入语言文件
const i18n = new vueI18n({
  //初始未选择浏览器默认语言 转换为小写 分别有zh zh-cn en en-us
  locale: localStorage.lang || 'zh-cn',
  //  locale:'zh-cn',
  messages: {
    //将我们项目中的语言包与Element的语言包进行合并
    'en': Object.assign(require('./lang/en'), require('./lang/class/en'), enLocale),
    'zh-cn': Object.assign(require('./lang/zh-CN'), require('./lang/class/zh'), zhLocale),
    'ja': Object.assign(require('./lang/ja'), require('./lang/class/ja'), jpLocale)
  },
});

Vue.use(ElementUI, {
  size: 'medium', // set element-ui default size
  //为了实现element插件的多语言切换
  i18n: (key, value) => i18n.t(key, value)
});
// Vue.use(i18n);

Vue.mixin({
  computed: {
    bosumYears() {
      return this.$store.getters.bosumYears
    }
  }
})

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js